import { ExposedApplicationDTOSchema } from '@doutorsim/shared/applications'
import { ExposedFacilityDTOSchema } from '@doutorsim/shared/facilities'
import { ExposedPersonDTOSchema } from '@doutorsim/shared/persons'
import { z } from 'zod'

export const UpdatePersonFormSchema = z.object({
  application: ExposedApplicationDTOSchema.pick({
    status: true,
  }).extend({
    facility: ExposedFacilityDTOSchema,
    person: ExposedPersonDTOSchema.pick({
      name: true,
      cpf: true,
      email: true,
      phone: true,
      createdAt: true,
    }),
  }),
})

export type TUpdatePersonForm = z.infer<typeof UpdatePersonFormSchema>
